import React, { useState, useEffect } from 'react';
import '../styles/Contact.css';

const SuccessMessage = ({ isVisible, language }) => {
  const successMessages = {
    EN: "Thank you! Your message has been sent.",
    中文: "谢谢！您的消息已发送。"
  };

  return (
    <div className={`success-message ${isVisible ? 'show' : ''}`}>
      {successMessages[language]}
    </div>
  );
};

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    country: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [language, setLanguage] = useState('EN');

  const content = {
    EN: {
      title: "Contact",
      nameLabel: "Hello, my name is",
      namePlaceholder: "enter your name",
      countryLabel: "My Country is",
      countryPlaceholder: "enter your country",
      emailLabel: "My email is",
      emailPlaceholder: "enter your email address here",
      messageLabel: "My Message",
      messagePlaceholder: "write your message here",
      sending: "Sending...",
      sendButton: "Send Message",
      socialTitle: "Follow Me"
    },
    中文: {
      title: "联系我",
      nameLabel: "你好，我的名字是",
      namePlaceholder: "请输入您的姓名",
      countryLabel: "我的国家是",
      countryPlaceholder: "请输入您的国家",
      emailLabel: "我的邮箱是",
      emailPlaceholder: "请在此输入您的邮箱地址",
      messageLabel: "我的留言",
      messagePlaceholder: "请在此写下您的留言",
      sending: "发送中...",
      sendButton: "发送消息",
      socialTitle: "关注我"
    }
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem('currentLanguage') || 'EN';
    setLanguage(savedLanguage);

    const handleLanguageChange = () => {
      const newLanguage = localStorage.getItem('currentLanguage') || 'EN';
      setLanguage(newLanguage);
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
      setFormData({ name: '', country: '', email: '', message: '' });
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <div className="contact-container">
      <SuccessMessage isVisible={showSuccess} language={language} />

      <h2 className="contact-title font-script">
        {content[language].title}
      </h2>

      <div className="form-card">
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">{content[language].nameLabel}</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={content[language].namePlaceholder}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="country">{content[language].countryLabel}</label>
            <input
              type="text"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleChange}
              placeholder={content[language].countryPlaceholder}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">{content[language].emailLabel}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={content[language].emailPlaceholder}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">{content[language].messageLabel}</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              placeholder={content[language].messagePlaceholder}
              required
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="btn-primary submit-btn"
          >
            {isSubmitting ? content[language].sending : content[language].sendButton}
          </button>
        </form>
      </div>

      <div className="social-links">
        <h3>{content[language].socialTitle}</h3>
        <div className="social-icons">
          <a
            href="https://www.youtube.com/@Daniinchina"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon youtube"
            aria-label="YouTube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.instagram.com/daninchina?igsh=MW9nanIzNGlkd3FsOA=="
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon instagram"
            aria-label="Instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://web.facebook.com/Daniinchina1?__tn__=-UC"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon facebook"
            aria-label="Facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
        </div>
      </div>
    </div>
  );
}

export default function Contact({ isSection = false }) {
  return (
    <div
      id="contact"
      className={isSection ? "contact-section" : "contact-page"}
      style={isSection ? { scrollMarginTop: '80px' } : {}}
    >
      <ContactForm />
    </div>
  );
}